import axios from 'axios';
import { Commentary } from '../../../../commentary/commentary.types';

export function getCommentariesLinkedToLegislation(
  docId: string,
  query: string,
): Promise<{ data: Array<Commentary> }> {
  return axios.get('/getCommentariesLinkedToLegislation', {
    params: {
      docId,
      query,
    },
  });
}
